import React from 'react';
import { Label } from '../Label/Label';

interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    id: string;
    'data-testid'?: string;
    variant?: 'boxed' | 'inline';
}

export const FormInput: React.FC<FormInputProps> = ({ label, id, className = '', 'data-testid': dataTestId, variant = 'boxed', ...props }) => {
    if (variant === 'inline') {
        return (
            <input
                id={id}
                data-testid={dataTestId}
                className={`w-full bg-transparent border-0 p-0 text-compact text-primary-1225 focus:outline-none disabled:text-content-secondary disabled:cursor-not-allowed touch-target field-text-mobile ${className}`}
                {...props}
            />
        );
    }

    return (
        <div className="flex flex-col gap-s">
            {label && <Label htmlFor={id}>{label}</Label>}
            <input
                id={id}
                data-testid={dataTestId}
                className={`h-9 px-m rounded-md border border-line bg-primary-50 text-primary-1225 text-compact placeholder:text-primary-600 focus:outline-none focus:border-focus focus:ring-4 focus:ring-focus-ring transition-colors disabled:bg-primary-200 disabled:text-content-secondary disabled:border-line disabled:cursor-not-allowed field-text-mobile ${className}`}
                {...props}
            />
        </div>
    );
};
